import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore/lite'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: 'AIzaSyCZ_Ieh1zQ5w662H0BcP5nElIQm4-OzVbo',
  authDomain: 'la-anlage.firebaseapp.com',
  databaseURL: 'https://la-anlage.firebaseio.com',
  projectId: 'la-anlage',
  storageBucket: 'la-anlage.appspot.com',
  messagingSenderId: '88296889122',
  appId: '1:88296889122:web:b868018fb67814aefbe37b',
  measurementId: 'G-RWLMF1XZQX',
}

const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)


new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
